import axios from "axios";
import { Resolution, ResolutionId } from "../tickets";
import { makeConfigApi } from "./makeConfigApi";

export type ResolutionConfigurationId = string & { __brand: "ResolutionConfigurationId" };
export type ResolutionConfiguration = {
    id: ResolutionConfigurationId;
    name: string;
    resolutions: Resolution[];
};

export type ResolutionApi = {
    getResolutionConfigurations(): Promise<ResolutionConfiguration[]>;
    createResolutionConfiguration(name: string): Promise<ResolutionConfiguration>;
    editResolutionConfiguration(config: ResolutionConfigurationId, name: string): Promise<void>;
    deleteResolutionConfiguration(config: ResolutionConfigurationId): Promise<void>;

    createResolution(
        config: ResolutionConfigurationId,
        name: string,
        description: string | null
    ): Promise<Resolution>;
    editResolution(
        config: ResolutionConfigurationId,
        resolution: ResolutionId,
        name: string,
        description: string | null
    ): Promise<void>;
    deleteResolution(config: ResolutionConfigurationId, resolution: ResolutionId): Promise<void>;
};

const configApi = makeConfigApi<ResolutionConfiguration>("resolutions");

export const resolutionApi: ResolutionApi = {
    getResolutionConfigurations: configApi.list,
    createResolutionConfiguration: configApi.create,
    editResolutionConfiguration: configApi.edit,
    deleteResolutionConfiguration: configApi.remove,

    async createResolution(config, name, description) {
        const { data: resolution } = await axios.post<Resolution>(
            `/api/v0/project-configurations/resolutions/${config}/resolutions`,
            { name, description }
        );
        return resolution;
    },
    async editResolution(config, resolution, name, description) {
        await axios.put(
            `/api/v0/project-configurations/resolutions/${config}/resolutions/${resolution}`,
            {
                name,
                description,
            }
        );
    },
    async deleteResolution(config, resolution) {
        await axios.delete(
            `/api/v0/project-configurations/resolutions/${config}/resolutions/${resolution}`
        );
    },
};
